module.exports = __webpack_public_path__ + "img/Balance-1.24bc9319.jpg";